/**
 * ServicesCacheSection - секция «Сервисы и сброс кэша».
 * Контейнер модулей сервисов: Google Таблицы, GPS, кэш данных и синхронизация.
 */
import React from 'react';
import { Box, Paper } from '@mui/material';
import { RestartAlt } from '@mui/icons-material';
import SectionHeaderDivider from './SectionHeaderDivider';

import GoogleSheetsServiceCard from './services/GoogleSheetsServiceCard';
import GeolocationServiceCard from './services/GeolocationServiceCard';
import DataCacheServiceCard from './services/DataCacheServiceCard';
import ProfileSyncServiceCard from './services/ProfileSyncServiceCard';

export interface ServicesCacheSectionProps {
  username: string;
  pharmacyNum?: string | null;
  pharmacyAddress?: string;
  latitude?: string | number | null;
  longitude?: string | number | null;
  accuracy?: number | null;
  /** Микросервис геолокаций не ответил: точка неизвестна, а не отсутствует */
  geoUnavailable: boolean;
  onGeoUpdated?: (geo: { latitude: number; longitude: number; accuracy?: number; address?: string }) => void;
  onSyncData: () => Promise<void>;
}

const ServicesCacheSection: React.FC<ServicesCacheSectionProps> = ({
  username,
  pharmacyNum,
  pharmacyAddress,
  latitude,
  longitude,
  accuracy,
  geoUnavailable,
  onGeoUpdated,
  onSyncData
}) => {
  return (
    <Paper
      id="section-services"
      elevation={0}
      sx={{
        p: { xs: 2.5, sm: 3.5 },
        borderRadius: '20px',
        bgcolor: '#ffffff',
        border: '1px solid #e2e8f0',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.03)',
        display: 'flex',
        flexDirection: 'column',
        gap: 3.5,
        scrollMarginTop: '24px'
      }}
    >
      <SectionHeaderDivider
        id="header-services"
        icon={<RestartAlt sx={{ fontSize: 22 }} />}
        title="Сервисы и сброс кэша"
        subtitle="Управление внешними модулями, сброс кэша Google Таблиц, диагностика геолокации и локальных данных"
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, containerType: 'inline-size' }}>
        {/* 1. Google Таблицы (Табель РБ) */}
        <GoogleSheetsServiceCard
          pharmacyNum={pharmacyNum}
        />

        {/* 2. Геолокация (GPS) */}
        <GeolocationServiceCard
          pharmacyAddress={pharmacyAddress}
          latitude={latitude}
          longitude={longitude}
          accuracy={accuracy}
          unavailable={geoUnavailable}
          onGeoUpdated={onGeoUpdated}
        />

        {/* 3. Кэш таблиц, журналов и отчетов */}
        <DataCacheServiceCard />

        {/* 4. Синхронизация профиля */}
        <ProfileSyncServiceCard
          username={username}
          onSyncData={onSyncData}
        />
      </Box>
    </Paper>
  );
};

export default ServicesCacheSection;
